export const INFINITY_PLACEHOLDER = " ";
